export default __webpack_public_path__ + "static/media/bionano2.401d12bb.png";